
<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-if="data.now && !data.now.VipCardImg" class="vipCard">
      <span v-if="!data.now.VipCardImg"><i :class="'iconfont '+data.now.VipIcon" :style="'color: '+GetColorMain()" /> {{ data.now.VipName }}</span>
    </div>
    <div v-if="data.now && data.now.VipCardImg" class="vipCardImg">
      <img :src="data.now.VipCardImg">
    </div>
    <div class="vipRect">
      <div class="title">
        <i :class="'iconfont '+data.now.VipIcon" :style="'color: '+GetColorMain()" /> {{ data.now.VipName }}权益
      </div>
      <div class="getRects">
        <div v-for="(item,index) in data.now.rigths" :key="index" class="getRect">
          <div class="icon"> <i :class="'iconfont '+item.icon" :style="'background-color: '+(data.now.color?data.now.color:'#ccc')" /></div>
          {{ item.title }}
        </div>
      </div>
      <div v-if="data.next" class="nextLevel">
        <van-row>
          <van-col span="12">升级{{ data.next.VipName }}</van-col>
          <van-col span="12" class="rigth upLevel" :style="'color: '+GetColorMain()"><span @click="onUpLevel(data.next.conditionUrl)">{{ data.next.conditionTitle }} </span></van-col>
        </van-row>
        <div class="need">{{ data.next.condition }}</div>
      </div>
      <div v-if="data.next" class="nextgetRects">
        升级{{ data.next.VipName }}后权益
        <div class="getNextRects">
          <div v-for="(item,index) in data.next.rigths" :key="index" class="getRect">
            <div class="icon"> <i :class="'iconfont '+item.icon" :style="'background-color: '+(data.now.color?data.now.color:'#ccc')" /></div>
            <div class="name"> {{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button } from 'vant'
import TopBar from '@/components/TopBar'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine, GetColorMainGradual } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      title: '会员中心',
      backurl: '/my/index',
      data: {
        now: undefined,
        next: undefined
      }
    }
  },

  created() {
    this.init()
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetColorMainGradual,
    init() {
      request({
        url: '/user/getVipPage',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
      })
    },
    onUpLevel(url) {
      this.$router.push(url)
    }
  }
}
</script>
<style scoped>
.vipCard{
  margin: 4vw;
  background-color: #fff;
  padding: 4.5em;
  text-align: center;
  border-radius: 0.5em;
}
.vipCard span{
  font-size:2em;
}
.vipCard i{
  font-size: 0.9em;
}
.vipCardImg
{
  margin: 4vw;
}
.vipCardImg img{
  width: 100%;
  border-radius: 0.5em;
}

.vipRect{
  margin: 4vw;
  background-color: #fff;
  border-radius: 0.5em;
}
.vipRect .title{
  text-align: center;
  border-bottom: 1px solid #eaeaea;
  padding: 0.8em 1em;
}

.getRects{
  display: flex;
  justify-content:flex-start;
  flex-wrap:  wrap;
  padding: 1vw 1vw;
  border-bottom: 1px solid #eaeaea;
}
.getRects .getRect
{
  width: 18vw;
  margin: 2.5vw 2.2vw;
  text-align: center;
  font-size: 0.8em;
}
.getRects .getRect .icon{
  height: 18vw;
  border-radius: 18vw;
  background-color: #ccc;
  line-height: 18vw;
  margin-bottom: 0.7em;
}
.getRects .getRect .icon i{
  font-size: 1.8em;
  color: #fff;
}
.nextLevel{
  padding: 2.5vw 4vw;
  border-bottom: 1px solid #eaeaea;
}
.nextLevel .upLevel{
  font-size: 0.9em;
}
.nextLevel .need{
  color: #999;
  font-size: 0.9em;
  padding: 1em 0;
}
.nextgetRects{
  padding: 2.5vw 4vw;
}
.nextgetRects .getNextRects{
  display: flex;
  flex-wrap:wrap;
}
.nextgetRects .getNextRects .getRect{
  position: relative;
  width: 50%;
  padding: 0.5em 0;
}
.nextgetRects .getNextRects .getRect .icon{
  height: 8vw;
  width: 8vw;
  text-align: center;
  line-height: 8vw;
  border-radius: 8vw;
  background-color: #ccc;
  color: #fff;
}
.nextgetRects .getNextRects .getRect .name{
  position: absolute;
  left: 10vw;
  top: 0.5em;
  line-height: 8vw;
  font-size: 0.8em;
}
</style>
